import React, { useEffect, useRef } from "react";

import GoldSpinner from "src/assets/Spinner/GoldSpinner";
import { applicationStyles as styles } from "./ApplicationLayout";

export const showError = ({ touched, error }) => !!(touched && error);

export const FieldShell = ({ id, label, hint, meta, className = "", children }) => (
  <div className={`${styles.field} ${className}`}>
    {label && <label className={styles.fieldLabel} htmlFor={id}>{label}</label>}
    {children}
    {hint && <div className={styles.fieldHint}>{hint}</div>}
    {showError(meta) && <div className={styles.error}>{meta.error}</div>}
  </div>
);

export const TextField = ({ input, meta, label, hint, prefix, ...inputProps }) => (
  <FieldShell id={input.name} label={label} hint={hint} meta={meta}>
    <div className={`${styles.box} ${styles.inputBox} ${showError(meta) ? styles.boxInvalid : ""}`}>
      {prefix && <span className={styles.prefix}>{prefix}</span>}
      <input {...input} {...inputProps} id={input.name} className={styles.input} />
    </div>
  </FieldShell>
);

export const Cta = ({ submitting, disabled, children }) => (
  <button type="submit" className={styles.cta} disabled={submitting || disabled}>
    {submitting ? <GoldSpinner size={22} /> : children}
  </button>
);

// Submit errors appear next to the button, which may be off screen on a long form, so the
// message brings itself into view.
export const SubmitError = ({ children }) => {
  const ref = useRef();
  useEffect(() => {
    if (ref.current) ref.current.scrollIntoView({ block: "center" });
  }, []);
  return (
    <div role="alert" ref={ref} className={styles.footerError}>
      {children}
    </div>
  );
};
